const defaultUrl =
  'https://jfbucket.oss-cn-hangzhou.aliyuncs.com/image/default/avatar.png'
const moment = require('moment')
import validateStatus from '@/config/validateStatus'
import Env from '@/config/env'

moment.defineLocale('zh-cn', {
  relativeTime: {
    future: '%s内',
    past: '%s前',
    s: '几秒',
    m: '1 分钟',
    mm: '%d 分钟',
    h: '1 小时',
    hh: '%d 小时',
    d: '1 天',
    dd: '%d 天',
    M: '1 个月',
    MM: '%d 个月',
    y: '1 年',
    yy: '%d 年'
  }
})

export const converTags = (tag = '') => {
  return tag.split(',')
}

export const converMoney = (money = 0) => {
  return money.toFixed(2) + '元'
}

/**
 * 将秒数转成分钟或秒 eg：10分钟 或 10秒
 * @param {string,Number}
 * @returns {string}
 */
export const converLengthTime = (time = 0) => {
  if (time / 60 >= 1) {
    return Math.floor((time / 60) * 10) / 10 + '分钟'
  } else {
    return time + '秒'
  }
}

/**
 * eg:超过999,显示999+
 * @param {string,Number}
 * @returns {string,Number}
 */
export const numberFilter = (num, maxNum) => {
  maxNum = parseInt(maxNum) || 999
  if (num < maxNum) {
    return num
  } else {
    return maxNum + '+'
  }
}

export const lastDayFilter = (time = '') => {
  return moment(time, 'YYYYMMDDHHmmss').fromNow()
}
// 阅读量超过1000以k计算
export const readNumber = nub => {
  if (nub > 999 && nub < 10000) {
    let data = (nub / 1000).toFixed(2) + 'k'
    return data
  } else if (nub > 9999) {
    let data = (nub / 10000).toFixed(2) + 'w'
    return data
  } else {
    return nub
  }
}
/**
 * @param {String,Number} //String:2020-07-29 09:15:45 Number:时间戳13位
 * @returns {string}
 * 获取某月的第一天时间
 */
export const NowFormatDate = (time = '', seperator1 = '-') => {
  if (typeof time == 'string') {
    time = time.replace(/-/g, '/') //ios 不兼容'-' 会变成NaN
  }
  time = new Date(time)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let strDate = time.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  let currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}

/**
 * @param {string}
 * @returns {string}
 * 获取时分 eg：20：00
 */
export const hoursMinute = (time = '') => {
  const colon = ':'
  let data = new Date(time)
  let hours = data.getHours()
  let minute = data.getMinutes()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  if (minute >= 0 && minute <= 9) {
    minute = '0' + minute
  }
  return hours + colon + minute
}

/**
 * @param {string}
 * @returns {string}
 * 获取月日时分 eg：20：00
 */
export const YRhoursMinute = (time = '', id = '1') => {
  const colon = ':'
  const yue = '月'
  const ri = '日'
  let data = new Date(time)
  let y = data.getFullYear()
  let years = data.getMonth() + 1
  let day = data.getDate()
  let hours = data.getHours()
  let minute = data.getMinutes()
  let s = data.getSeconds()
  if (years >= 0 && years <= 9) {
    years = '0' + years
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  if (minute >= 0 && minute <= 9) {
    minute = '0' + minute
  }
  if (s >= 0 && s <= 9) {
    s = '0' + s
  }
  let times = years + yue + day + ri + hours + colon + minute
  if (id == 2) {
    times = y + '/' + years + '/' + day + ' ' + hours + ':' + minute + ':' + s
  }
  return times
}

/**
 * formatMoney(value,type)
 * 功能：金额按千位逗号分割
 * @param {Number,string} value 需要格式化的金额数值.
 * @param {string} type 判断格式化后的金额是否需要小数位.
 * @returns {string} 返回格式化后的数值字符串.eg:10,000.00
 */
export const formatMoney = (value, type) => {
  // if (/[^0-9\.]/.test(value)) return '0' //还没有检查这个报错是什么意思
  if (value == null || value == '') return '0'
  value = value.toString().replace(/^(\d*)$/, '$1.')
  value = (value + '00').replace(/(\d*\.\d\d)\d*/, '$1')
  value = value.replace('.', ',')
  var re = /(\d)(\d{3},)/
  while (re.test(value)) value = value.replace(re, '$1,$2')
  value = value.replace(/,(\d\d)$/, '.$1')
  if (type == 0) {
    // 不带小数位(默认是有小数位)
    var a = value.split('.')
    if (a[1] == '00') {
      value = a[0]
    }
  }
  return value
}

/**
 * @param {string}
 * @returns {string} 今天12:00，明天12:00，后天12:00，具体时间11-11 11:11
 */
export const switchTime = (time = '') => {
  time = time.replace(/-/g, '/') //ios 不兼容'-' 会变成NaN
  const now = new Date().setHours(23, 59, 59, 999) //获取今天晚上12点时间戳
  const datanow = new Date()
  const data = new Date(time)
  const returnTime = data.getTime() //后台返回时间
  const oneDay = 24 * 60 * 60 * 1000
  const colon = ':'
  let hours = data.getHours()
  let minute = data.getMinutes()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  if (minute >= 0 && minute <= 9) {
    minute = '0' + minute
  }
  if (datanow > returnTime) {
    let month = data.getMonth() + 1
    let day = data.getDate()
    if (month >= 0 && month <= 9) {
      month = '0' + month
    }
    if (day >= 0 && day <= 9) {
      day = '0' + day
    }
    return month + '月' + day + '日 ' + hours + colon + minute
  } else if (returnTime < now) {
    return '今天 ' + hours + colon + minute
  } else if (returnTime > now && returnTime - now < oneDay * 1) {
    return '明天 ' + hours + colon + minute
  } else if (returnTime - now > oneDay && returnTime - now < oneDay * 2) {
    return '后天 ' + hours + colon + minute
  } else {
    // 具体日期
    let date = new Date()
    let yearnew = date.getFullYear()
    let year = data.getFullYear()
    let month = data.getMonth() + 1
    let day = data.getDate()
    if (month >= 0 && month <= 9) {
      month = '0' + month
    }
    if (day >= 0 && day <= 9) {
      day = '0' + day
    }
    if (yearnew == year) {
      return month + '月' + day + '日 ' + hours + colon + minute
    } else {
      return year + '年' + month + '月' + day + '日 ' + hours + colon + minute
    }
  }
}

/**
 * 功能：将时间 (2021-01-26 或 2021-01-26 16:42) 转化为中文日期 (2021年1月26日)
 * @param {string} 2021-01-26 或 2021-01-26 16:42
 * @return {string} 2021年1月26日
 */
export const NowFormatDateNew = (time = '', showYear = false) => {
  if (typeof time == 'string') {
    time = time.replace(/-/g, '/') //ios 不兼容'-' 会变成NaN
  }
  let date = new Date()
  let yearnew = date.getFullYear()
  time = new Date(time)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let strDate = time.getDate()
  if (showYear) {
    return year + '年' + month + '月' + strDate + '日'
  } else {
    if (yearnew == year) {
      return month + '月' + strDate + '日'
    } else {
      return year + '年' + month + '月' + strDate + '日'
    }
  }
}

/**
 * 功能：将时间 (2021-01-26 或 2021-01-26 16:42) 转化为中文日期 (2021-1-26)
 * @param {string} 2021-01-26 或 2021-01-26 16:42
 * @return {string} 2021年1月26日
 */
export const NowFormatDateNew1 = (time = '', showYear = false) => {
  if (typeof time == 'string') {
    time = time.replace(/-/g, '/') //ios 不兼容'-' 会变成NaN
  }
  let date = new Date()
  let yearnew = date.getFullYear()
  time = new Date(time)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let strDate = time.getDate()
  let hours = date.getHours()
  let minute = date.getMinutes()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  if (minute >= 0 && minute <= 9) {
    minute = '0' + minute
  }
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 1 && strDate <= 9) {
    strDate = '0' + strDate
  }
  if (showYear) {
    return year + '-' + month + '-' + strDate
  } else {
    if (yearnew == year) {
      return month + '月' + strDate + '日'
    } else {
      return year + '年' + month + '月' + strDate + '日 ' + hours + ':' + minute
    }
  }
}

/**
 * 功能：头像图片过滤，没有头像会返回一个默认头像
 * @param {string} url
 * @return {string}
 */
export const avatarImgFilter = (url = '') => {
  if (url.indexOf('/image/') === 0) {
    return Env.ossFileUrl + url + '!zf_200'
  } else if (url.indexOf('image/') === 0) {
    return Env.ossFileUrl + '/' + url + '!zf_200'
  } else if (url.indexOf(Env.ossFileUrl) >= 0 && url.indexOf('?') == -1) {
    return url + '!zf_200'
  } else if (!url) {
    return defaultUrl
  } else {
    return url
  }
}

/**
 * 功能：处理成一个正方形400的图片
 * @param {string} url
 * @return {string}
 */
export const img400Filter = (url = '') => {
  if (url.indexOf('/image/') === 0) {
    return Env.ossFileUrl + url + '!zf_400'
  } else if (url.indexOf('image/') === 0) {
    return Env.ossFileUrl + '/' + url + '!zf_400'
  } else {
    return url + '!zf_400'
  }
}

/**
 * 功能：处理成一个等比压缩365宽度的图片
 * @param {string} url
 * @return {string}
 */
export const imgDb400Filter = (url = '') => {
  if (url.indexOf('/image/') === 0) {
    return Env.ossFileUrl + url + '?x-oss-process=image/resize,m_lfit,w_365'
  } else if (url.indexOf('image/') === 0) {
    return (
      Env.ossFileUrl + '/' + url + '?x-oss-process=image/resize,m_lfit,w_365'
    )
  } else {
    return url
  }
}

/**
 * 功能：处理普通图片
 * @param {string} url
 * @return {string}
 */
export const imgFilter = (url = '') => {
  if (url.indexOf('/image/') === 0) {
    return Env.ossFileUrl + url
  } else if (url.indexOf('image/') === 0) {
    return Env.ossFileUrl + '/' + url
  } else {
    return url
  }
}

/**
 * 功能：处理名字，如果是名字是手机号码，会对中间进行加密
 * @param {string} url
 * @return {string}
 */
export const nameFilter = (name = '') => {
  if (IsPhoneAvailable(name)) {
    return name.substring(0, 3) + '****' + name.substring(7, 11)
  } else {
    return name
  }
}

/**
 * 功能：处理数字，超过9999，显示万单位
 * eg：1万，1.2万，12万
 * @param {number,string}
 * @return {string}
 */
export const converNumber = (num = 0) => {
  let number = Number(num)
  if (number < 10000) {
    return number
  } else {
    number = (number / 10000).toFixed(1)
    const strArr = number.split('.')
    if (strArr[1] == 0) {
      return strArr[0] + '万'
    } else {
      return number + '万'
    }
  }
}

/**
 * 功能：英式处理数字，超过9999，显示万单位
 * eg：1w，1.2w，12w
 * @param {number,string}
 * @return {string}
 */
export const converNumberBritish = (num = 0) => {
  let number = Number(num)
  if (number < 10000) {
    return number
  } else {
    number = (number / 10000).toFixed(1)
    const strArr = number.split('.')
    if (strArr[1] == 0) {
      return strArr[0] + 'w'
    } else {
      return number + 'w'
    }
  }
}

/**
 * 功能：处理数字，超过999，显示千单位
 * eg：1K，1.2K，12K
 * @param {number,string}
 * @return {string}
 */
export const converNumberThou = num => {
  let number = Number(num)
  if (number < 1000) {
    return number
  } else {
    number = (number / 1000).toFixed(1)
    const strArr = number.split('.')
    if (strArr[1] == 0) {
      return strArr[0] + 'K'
    } else {
      return number + 'K'
    }
  }
}

/**
 * 将秒数转成时间 eg：01:00 / 01:02:00
 * @param {Number}
 * @returns {string}
 */
export const durationFormat = (duration = 0) => {
  let hours = Math.floor(duration / 3600)
  let minute = Math.floor((duration - hours * 3600) / 60)
  let seconds = Math.floor(duration - hours * 3600 - minute * 60)
  hours = hours.toString().length < 2 ? `0${hours}` : hours
  minute = minute.toString().length < 2 ? `0${minute}` : minute
  seconds = seconds.toString().length < 2 ? `0${seconds}` : seconds
  return hours == '00'
    ? `${minute}:${seconds}`
    : `${hours}:${minute}:${seconds}`
}

export const calcDay = (createTime = '') => {
  const now = Date.now()
  const time = Date.parse(createTime)
  const day = Math.floor((now - time) / 86400000)
  return day
}

/**
 * 验证手机号码格式是否正确
 * @param {Number,String}
 * @returns {Boolean}
 */
export const IsPhoneAvailable = phone => {
  let myreg = /^1[3456789]\d{9}$/
  return myreg.test(phone)
}

/**
 * 用户身份名称转换
 * @param {Number,String}
 * @returns {Boolean}
 */
export const validateStatusName = type => {
  for (let i = 0; i < validateStatus.length; i++) {
    if (validateStatus[i].id === type) {
      return validateStatus[i].name
    }
  }
}

// 获取当前时间，格式：2021.12.12
export const timeFormate = (time = '', seperator1 = '.') => {
  if (typeof time == 'string') {
    time = time.replace(/-/g, '/') //ios 不兼容'-' 会变成NaN
  }
  time = new Date(time)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let strDate = time.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  let currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}

/**
 * 功能：列表倒计时
 * @param {string} maxtime 需要传入的时间戳.
 * @param {function} fn 传入的回调函数.
 * @returns {string} 返回格式化：倒计时
 */
export const countDown = (maxtime, fn) => {
  let newdate = new Date().getTime() / 1000
  let datetime = maxtime - newdate
  let timer = setInterval(function() {
    if (datetime > 0) {
      let day = Math.floor(datetime / 86400)
      let hour = Math.floor((datetime % 86400) / 3600)
      let minutes = Math.floor((datetime % 3600) / 60)
      let seconds = Math.floor(datetime % 60)
      if (day > 0) {
        hour += day * 24
      }

      let msg =
        '剩余' +
        (hour < 10 ? '0' + hour : hour) +
        ':' +
        (minutes < 10 ? '0' + minutes : minutes) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds)
      fn(msg)

      --datetime
    } else {
      clearInterval(timer)

      fn('已结束')
    }
  }, 1000)
}

export const DatePoor = TIME => {
  if (TIME.length === 0) {
    return ''
  }
  const data = new Date(TIME).getTime()
  const now = new Date().getTime()
  const TimeDifference = Math.floor(
    Number(((now - data) / (60 * 60 * 1000)).toFixed(2))
  )
  if (TimeDifference === 0) {
    return '1小时内'
  }
  if (TimeDifference < 12) {
    return TimeDifference + '小时前'
  }

  const now2 = new Date().setHours(23, 59, 59, 999)
  const TimeDifference2 = Math.floor(
    Number(((now2 - data) / (24 * 60 * 60 * 1000)).toFixed(2))
  )
  if (TimeDifference2 === 0) {
    return '今天'
  }
  if (TimeDifference2 === 1) {
    return '昨天'
  }
  if (TimeDifference2 > 1 && TimeDifference2 < 6) {
    return TimeDifference2 + '天前'
  }
  return TIME.split(' ')[0]
}

// 1万人以下显示纯数字，如9999，1万人以上显示数字(精确到小数点后两位)+万;
export const formatNumber = num => {
  // 判断数字是否大于或等于10000
  if (num >= 10000) {
    // 如果是，则除以10000，保留两位小数，并加上'万'字
    return (num / 10000).toFixed(2) + '万'
  } else {
    // 如果不是，则直接返回数字（转换为字符串）
    return num.toString()
  }
}

/**
 * 功能：处理Swjj普通图片
 * @param {string} url
 * @return {string}
 */
export const imgFilterSwjj = (url = '') => {
  if (url.indexOf('/image/') === 0) {
    return 'http://zhilvchuxing.oss-cn-shenzhen.aliyuncs.com' + url
  } else if (url.indexOf('image/') === 0) {
    return 'http://zhilvchuxing.oss-cn-shenzhen.aliyuncs.com' + '/' + url
  } else {
    return url
  }
}
